import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import './PracticePerfectQuizzes.css';
import Header from '../../Header/Header';
import { withAuth } from "../../../app/util/HOC";
import { handleException } from '../../../app/util/util';
export function PPPreviouslyWatchedQuizzes() {
    const { isbn } = useParams();
    const history = useHistory();
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const ppPageInfo = JSON.parse(localStorage.getItem('ppLandingInfo'));
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const [prevCustTime, setPrevCustTime] = useState();
    const [prevSelMaxQues, setPrevSelMaxQues] = useState();
    const [prevWatchTopics, setPrevWatchTopics] = useState([]);
    const [prevCustMaxQues, setPrevCustMaxQues] = useState();
    const [prevTakeQuizErrMsg, setPrevTakeQuizErrMsg] = useState('');
    const getSessionVO = () => {
        return {
            "appType": "web",
            "deviceMacId": "",
            "keepMeLoggedInFlag": keepMeLogIn,
            "deviceOS": localStorage.getItem('deviceOS'),
            "deviceType": localStorage.getItem('deviceType'),
            "browserName": localStorage.getItem('browserName'),
            "sessionAuthenticationToken": userVO.sessionAuthenticationToken
        }
    }
    function fetchPrevWatchVidTopics() {
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "themisProductId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "themisSubjectAreaId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "schoolId": userVO.schoolId,
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                    "ppSubjectAreaTagId": ppPageInfo.SATagId
                },
                "sessionVO": getSessionVO()
            },
            "ppSubjectAreaTagId": ppPageInfo.SATagId,
            "ppProductVO": { "productId": ppPageInfo.ProductID }
        };
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        };
        fetch(`${localStorage.getItem('ENV')}/managePP/getPreviouslyWatchedVideos`, requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true" && data.ppTopicVOList) {
                    data.ppTopicVOList = Array.isArray(data.ppTopicVOList) ? data.ppTopicVOList : [data.ppTopicVOList];
                    data.ppTopicVOList = data.ppTopicVOList.map(ppTopic => {
                        if (ppTopic.ppSubTopicVOList) {
                            ppTopic.ppSubTopicVOList = Array.isArray(ppTopic.ppSubTopicVOList) ? ppTopic.ppSubTopicVOList : [ppTopic.ppSubTopicVOList];
                            ppTopic.ppSubTopicVOList = ppTopic.ppSubTopicVOList.map(ppSubTopic => {
                                return { ...ppSubTopic, subTopic_select_status: false }
                            });
                        }
                        return { ...ppTopic, topic_select_status: false, subTopic_select_count: 0 }
                    });
                    setPrevWatchTopics(data.ppTopicVOList);
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    useEffect(() => {
        fetchPrevWatchVidTopics();
    }, []);
    const handleBackToQuizCenter = () => {
        history.push(`/pp-quiz-center/${isbn}`);
    }
    function handleTopicSelection(topicIndex, topicExpSta) {
        var selectedMaxQues = 0;
        const newTopicSelection = prevWatchTopics.map(ppTopic => {
            if (ppTopic.topicTagId === topicIndex) {
                ppTopic.topic_select_status = topicExpSta;
                if (topicExpSta == true) {
                    ppTopic.subTopic_select_count = ppTopic.ppSubTopicVOList.length;
                } else {
                    ppTopic.subTopic_select_count = 0;
                }
                ppTopic.ppSubTopicVOList = ppTopic.ppSubTopicVOList.map(ppSubTopic => {
                    ppSubTopic.subTopic_select_status = topicExpSta;
                    return ppSubTopic;
                });
            }
            return ppTopic;
        });
        newTopicSelection.forEach(ppTopic => {
            ppTopic.ppSubTopicVOList.forEach(ppSubTopic => {
                if (ppSubTopic.subTopic_select_status === true) {
                    selectedMaxQues += Number(ppSubTopic.totalQuestions)
                }
            });
        });
        if (selectedMaxQues < 60) {
            setPrevSelMaxQues(selectedMaxQues);
        } else {
            setPrevSelMaxQues(60);
        }
        setPrevWatchTopics(newTopicSelection);
    }
    function handleSubTopicSelection(topicIndex, subTopicIndex, subTopicExpSta) {
        var selectedMaxQues = 0;
        const newTopicSelection = prevWatchTopics.map(ppTopic => {
            if (ppTopic.topicTagId === topicIndex) {
                ppTopic.ppSubTopicVOList = ppTopic.ppSubTopicVOList.map(ppSubTopic => {
                    if (ppSubTopic.subTopictagId === subTopicIndex) {
                        ppSubTopic.subTopic_select_status = subTopicExpSta;
                        if (ppSubTopic.subTopic_select_status === true) {
                            ppTopic.subTopic_select_count += 1;
                        } else {
                            ppTopic.subTopic_select_count -= 1;
                        }
                    }
                    return ppSubTopic;
                });
                if (ppTopic.subTopic_select_count === ppTopic.ppSubTopicVOList.length) {
                    ppTopic.topic_select_status = true;
                } else {
                    ppTopic.topic_select_status = false;
                }
            }
            return ppTopic;
        });
        newTopicSelection.forEach(ppTopic => {
            ppTopic.ppSubTopicVOList.forEach(ppSubTopic => {
                if (ppSubTopic.subTopic_select_status === true) {
                    selectedMaxQues += Number(ppSubTopic.totalQuestions)
                }
            });
        });
        if (selectedMaxQues < 60) {
            setPrevSelMaxQues(selectedMaxQues);
        } else {
            setPrevSelMaxQues(60);
        }
        setPrevWatchTopics(newTopicSelection);
    }
    const handleCustQuizRadioBtn = (radioBtn) => {
        if (radioBtn === "custQuesRadBtn") {
            document.getElementById('custQuesRadBtn').checked = true;
        } else if (radioBtn === "custTimRadBtn") {
            document.getElementById('custTimRadBtn').checked = true;
        }
    }
    const handleCustQuizTakeQuizBtn = () => {
        var maxQuesRadBtnChe = document.getElementById('maxQuesRadBtn').checked,
            custQuesRadBtnChe = document.getElementById('custQuesRadBtn').checked,
            maxTimRadBtnChe = document.getElementById('maxTimRadBtn').checked,
            custTimRadBtnChe = document.getElementById('custTimRadBtn').checked;
        var takeQuizErrMsg = '', takeQuizType = 'Previously Watched', takeQuizTopics = [];
        if (prevSelMaxQues === undefined || prevSelMaxQues === 0) {
            takeQuizErrMsg = 'Please select at least one topic.';
        } else {
            if (maxQuesRadBtnChe === true && maxTimRadBtnChe === true) {
                takeQuizErrMsg = '';
            } else if (maxQuesRadBtnChe === true && custTimRadBtnChe === true) {
                if (prevCustTime === undefined || prevCustTime <= 0) {
                    takeQuizErrMsg = 'Please enter a time limit.';
                } else if (prevCustTime > 300) {
                    takeQuizErrMsg = 'Please enter a time limit between 1 and 300 minutes.';
                } else {
                    takeQuizErrMsg = '';
                }
            } else if (custQuesRadBtnChe === true && maxTimRadBtnChe === true) {
                if (prevCustMaxQues === undefined || prevCustMaxQues <= 0) {
                    takeQuizErrMsg = 'Please enter a valid number of questions.';
                } else if (prevCustMaxQues > prevSelMaxQues) {
                    takeQuizErrMsg = 'Please enter a number of questions between 1 and ' + prevSelMaxQues + '.';
                } else {
                    takeQuizErrMsg = '';
                }
            } else if (custQuesRadBtnChe === true && custTimRadBtnChe === true) {
                if (prevCustTime === undefined || prevCustTime <= 0) {
                    takeQuizErrMsg = 'Please enter a time limit.';
                } else if (prevCustTime > 300) {
                    takeQuizErrMsg = 'Please enter a time limit between 1 and 300 minutes.';
                } else if (prevCustMaxQues === undefined || prevCustMaxQues <= 0) {
                    takeQuizErrMsg = 'Please enter a valid number of questions.';
                } else if (prevCustMaxQues > prevSelMaxQues) {
                    takeQuizErrMsg = 'Please enter a number of questions between 1 and ' + prevSelMaxQues + '.';
                } else {
                    takeQuizErrMsg = '';
                }
            }
        }
        setPrevTakeQuizErrMsg(takeQuizErrMsg);
        if (takeQuizErrMsg === '') {
            prevWatchTopics.forEach(ppTopic => {
                ppTopic.ppSubTopicVOList.forEach((ppSubTopic) => {
                    if (ppSubTopic.subTopic_select_status === true) {
                        takeQuizTopics.push(ppSubTopic.subTopictagId);
                    }
                });
            });
            localStorage.setItem('quCeGraModeQuizData', JSON.stringify({
                "isGraded": true,
                "quizType": takeQuizType,
                "subTopicTagId": takeQuizTopics,
                "quizTiming": custTimRadBtnChe === true ? prevCustTime : 300,
                "totalQuestions": custQuesRadBtnChe === true ? prevCustMaxQues : prevSelMaxQues
            }));
            history.push(`/pp-quiz/graded/${isbn}/${ppPageInfo.ProductID}/${ppPageInfo.SATagId}/previously-watched`);
        }
    }
    return (
        <>
            <Header userVO={userVO} pageName="CCPracticePerfect" isbn={isbn}></Header>
            <div className='container'>
                <div className="card ppQuizCenterContainerSection">
                    <div className="card-body ppQuizCenterContainerCard">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="ppQuizCenterLogoContainer">
                                    <p>
                                        <span className='ppQuizCenterCommonStyle ppQuizCenterLogoBoldText'>PracticePerfect<sup>TM</sup></span>
                                        <span className='ppQuizCenterCommonStyle ppQuizCenterLogoText'>{ppPageInfo.ProductName}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        {
                            prevWatchTopics &&
                            <div className='row mt-3'>
                                <div className='col-12'>
                                    <div className='ppQuizCenterCommonStyle ppQuizCenterTitle mb-1'> Quiz Center</div>
                                    <div className='ppQuizCenterCommonStyle ppQuizCenterText mb-1'>Previously Watched </div>
                                    <div className="pwQuizCenterBackBtn col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 no-padding">
                                        <a onClick={() => handleBackToQuizCenter()}>
                                            <span className="fa fa-chevron-left fa-sm" style={{ fontWeight: '600' }}></span>
                                            <span style={{ paddingLeft: '4px', fontSize: '15px' }}>Back to Quiz Center</span>
                                        </a>
                                    </div>
                                    <p className='ppQuizCenterCommonStyle ppQuizCenterTitle mb-1 mt-4'> Topics Selected</p>
                                    <p className='ppQuizCenterCommonStyle ppQuizCenterText'>Questions from the following videos you've watched: </p>
                                    <div className='row pwQuizTopicHeaderStyle'>
                                        {
                                            prevWatchTopics.map(ppTopic => {
                                                return (
                                                    <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12'>
                                                        <input data-testid={`input_check_${ppTopic.orderIndex}`} type="checkbox" id={ppTopic.topicTagId} className="form-check-input"
                                                            checked={ppTopic.topic_select_status === true}
                                                            onChange={() => handleTopicSelection(ppTopic.topicTagId, ppTopic.topic_select_status === true ? false : true)}
                                                        />
                                                        <label className="pwQuizTopicHeader">{ppTopic.topicName}</label>
                                                        <div className='row pwQuizSubTopicHeaderStyle'>
                                                            {
                                                                ppTopic.ppSubTopicVOList.map(ppSubTopic => {
                                                                    return (
                                                                        <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-2'>
                                                                            <input data-testid={`input_check_${ppTopic.orderIndex}_${ppSubTopic.orderIndex}`} type="checkbox" id={ppSubTopic.subTopictagId} className="form-check-input"
                                                                                checked={ppSubTopic.subTopic_select_status === true}
                                                                                onChange={() => handleSubTopicSelection(ppTopic.topicTagId, ppSubTopic.subTopictagId, ppSubTopic.subTopic_select_status === true ? false : true)} />
                                                                            <label className="pwQuizSubTopicHeader">{ppSubTopic.subTopicName}</label>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className='pwQuizBorder row'></div>
                                    <div className='pwQuizCustomize'>
                                        <p className='ppQuizCenterCommonStyle ppQuizCenterTitle mb-1 mt-4'> Customize your quiz</p>
                                        <div className='row mt-2'>
                                            <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12'>
                                                <p className='ppQuizCenterCommonStyle ppQuizCenterText'>
                                                    Number of questions {prevSelMaxQues !== undefined ? `(Max: ` + prevSelMaxQues + ` questions)` : null}
                                                </p>
                                                <div className="form-check ml-5 mb-3">
                                                    <input data-testid="input_radio_maximum_questions" type="radio" className="form-check-input" name="radioBtn1" id="maxQuesRadBtn"
                                                        onClick={() => [setPrevCustMaxQues(""), setPrevTakeQuizErrMsg("")]} defaultChecked={true} />
                                                    <label className="ppQuizCenterCommonStyle pwQuizSubTopicHeader"> Maximum </label>
                                                </div>
                                                <div className="form-check ml-5">
                                                    <input data-testid="input_radio_custom_questions" type="radio" className="form-check-input" name="radioBtn1" id="custQuesRadBtn" />
                                                    <input data-testid="input_questions" type="number" className="pwQuesInput mr-1 rounded-0" value={prevCustMaxQues}
                                                        onChange={(e) => setPrevCustMaxQues(e.target.value)} onClick={() => handleCustQuizRadioBtn("custQuesRadBtn")} />
                                                    <label className="ppQuizCenterCommonStyle pwQuizSubTopicHeader"> questions</label>
                                                </div>
                                            </div>
                                            <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12'>
                                                <p className='ppQuizCenterCommonStyle ppQuizCenterText'>Time Limit</p>
                                                <div className="form-check ml-5 mb-3">
                                                    <input data-testid="input_radio_unlimited_time" type="radio" className="form-check-input" name="radioBtn2" id="maxTimRadBtn"
                                                        onClick={() => [setPrevCustTime(""), setPrevTakeQuizErrMsg("")]} defaultChecked={true} />
                                                    <label className="ppQuizCenterCommonStyle pwQuizSubTopicHeader"> Unlimited Time</label>
                                                </div>
                                                <div className="form-check ml-5">
                                                    <input data-testid="input_radio_custom_time" type="radio" className="form-check-input" name="radioBtn2" id="custTimRadBtn" />
                                                    <input data-testid="input_time" type="number" className="pwQuesInput mr-1 rounded-0" value={prevCustTime}
                                                        onChange={(e) => setPrevCustTime(e.target.value)} onClick={() => handleCustQuizRadioBtn("custTimRadBtn")} />
                                                    <label className="ppQuizCenterCommonStyle pwQuizSubTopicHeader"> minutes</label>
                                                </div>
                                            </div>
                                        </div>
                                        {prevTakeQuizErrMsg && <p className='pwTakeQuizErrTxt mt-2'>{prevTakeQuizErrMsg}</p>}
                                    </div>
                                    <button className='pwTakeQuizBtn' onClick={() => handleCustQuizTakeQuizBtn()}>Take Graded Quiz</button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
export default withAuth(PPPreviouslyWatchedQuizzes);